export default __webpack_public_path__ + "static/iso27001-logo-3f7184496ea26700b5f1c79dc9066ffa.svg";